import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
// import FilterTable from '../../../components/FilterTable';
import GetInvestorPortfolio from '../../../APIs/InvestorPortfolio/GetInvestorPortfolio';
import InvestorProjectCard from './InvestorProjectCard';
import PageHeading from '../../../components/PageHeading';
import Loader from '../../../components/Loader';

export default function InvestorProjects() {
    const { investorId } = useParams();
    const [investorData, setInvestorData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [numberPages, setNumberOfPages] = useState([])
    const [loader, setLoader] = useState(1)

    const loadInvestorPortfolio = async () => {
        try {
            let response = await GetInvestorPortfolio(investorId);
            if (response?.status === 1) {
                setInvestorData(response?.responseValue?.reverse());
            }
            else {
                setInvestorData([]);
            }
        }
        catch (e) {
            setInvestorData([]);
        }
        finally {
            setLoader(0);
        }
    }

    const handlePrevious = () => {
        if (pageNumber !== 1) {
            setPageNumber(state => state - 1)
        }
        else {

        }
    }
    const handleNext = () => {
        if (pageNumber < numberPages?.length) {
            setPageNumber(state => state + 1);
        }
    };

    useEffect(() => {
        loadInvestorPortfolio();
    }, [investorId])
    return (
        <>
            <div className='container-fluid  '>
                <PageHeading pagename={"Investor Projects"} />
                <div className='project-conatiner mb-4'>
                    {
                        investorData && investorData?.slice(((pageSize * pageNumber) - pageSize), pageSize * pageNumber).map((val, ind) => {
                            return (
                                <InvestorProjectCard projectData={val} />
                            )
                        })
                    }

                </div>

                {investorData?.length > 10 && (
                    <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-end">

                            <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handlePrevious();
                                    }}
                                >
                                    Previous
                                </Link>
                            </li>

                            {numberPages?.map((val, ind) => (
                                <li
                                    className={`page-item ${pageNumber === ind + 1 ? "active" : ""}`}
                                    key={ind}
                                >
                                    <Link
                                        className="page-link"
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setPageNumber(ind + 1);
                                        }}
                                    >
                                        {ind + 1}
                                    </Link>
                                </li>
                            ))}

                            <li
                                className={`page-item ${pageNumber === numberPages?.length ? "disabled" : ""
                                    }`}
                            >
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNext();
                                    }}
                                >
                                    Next
                                </Link>
                            </li>

                        </ul>
                    </nav>
                )}
            </div>
            <Loader show={loader} />
        </>
    )
}
